import { loggedOutUser } from "core/redux/actions/user/userActions";
import configurationReducer from "core/redux/reducers/configuration/configurationReducer";
import type { ConfigurationState } from "core/redux/reducers/configuration/configurationReducer.types";
import userReducer from "core/redux/reducers/user/userReducer";
import type { UserState } from "core/redux/reducers/user/userReducer.types";
import type { AppActions } from "core/redux/store/configureStore.types";
import dataAnalyzerReducer from "dataAnalyzer/redux/reducers/dataAnalyzerReducer";
import type { DataAnalyzerState } from "dataAnalyzer/redux/reducers/dataAnalyzerReducer.types";
import entityHierarchyReducer, {
  type EntityHierarchiesState,
} from "entityHierarchy/redux/reducers/entityHierarchyReducer";
import type { AnyAction, Reducer } from "redux";
import { combineReducers } from "redux";
import type { RouterState } from "redux-first-history";
import sequenceAnalyserReducer from "sequenceAnalyser/redux/reducers/sequenceAnalyserReducer";
import type { SequenceAnalyserState } from "sequenceAnalyser/redux/reducers/sequenceAnalyserReducer.types";

import errorReducer from "./error/errorReducer";
import type { ErrorState } from "./error/errorReducer.types";
import notificationReducer from "./notification/notificationReducer";
import type { NotificationState } from "./notification/notificationReducer.types";
import pageReducer from "./page/pageReducer";
import type { PageState } from "./page/pageReducer.types";
import uiReducer from "./ui/uiReducer";
import type { UIState } from "./ui/uiReducer.types";

export interface ApplicationState {
  router: RouterState;
  user: UserState;
  configuration: ConfigurationState;
  notification: NotificationState;
  page: PageState;
  ui: UIState;
  entityHierarchy: EntityHierarchiesState;
  sequenceAnalyser: SequenceAnalyserState;
  error: ErrorState;
  dataAnalyzer: DataAnalyzerState;
}

const appReducer = (routerReducer: Reducer<RouterState, AppActions>) =>
  combineReducers<ApplicationState>({
    router: routerReducer,
    user: userReducer(),
    configuration: configurationReducer(),
    notification: notificationReducer,
    page: pageReducer(),
    ui: uiReducer,
    entityHierarchy: entityHierarchyReducer,
    sequenceAnalyser: sequenceAnalyserReducer,
    error: errorReducer,
    dataAnalyzer: dataAnalyzerReducer,
  });

const rootReducer = (
  state: ApplicationState | undefined,
  action: AnyAction,
  routerReducer: Reducer<RouterState, AppActions>
) => {
  // Reset the store to its initial state when the user logs out
  // Still pass down the action as it will create a flag within the user state
  // that will be used to re-initialize the app (using initApp action)
  if (loggedOutUser.match(action)) {
    return appReducer(routerReducer)(undefined, loggedOutUser);
  }

  return appReducer(routerReducer)(state, action);
};

export default rootReducer;
